module.exports = __webpack_public_path__ + "media/images/camera-06d8c5ee45536d32efa01219ddb9714d.svg";